import PricesAndPlansDocuments from './PricesAndPlansDocuments';

export default PricesAndPlansDocuments;
